import { Component, EventEmitter, Output, Input, OnChanges, SimpleChanges, ContentChild, TemplateRef, OnInit, ChangeDetectorRef, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { MAT_SELECT_CONFIG, MatSelectChange } from '@angular/material/select'; 
import { IAmbassadorPlan, IPlan, PlanService } from 'src/app/services/plan.service';  
import { Repetition, DurationType } from '../../../../../services/external/config/plans';

export class PartnerPriceModel{ 
}

@Component({
    selector: 'partner-plan',
    templateUrl: './partner-plan.component.html',
    styleUrls: ['./partner-plan.component.less']
})
export class PartnerPlanComponent implements OnInit {


    @Input("value") model: PartnerPriceModel; 
    @Input("planFileName") fileName: string; 

    repetitionTypes: any = Repetition;
    durationTypes: any = DurationType;

    plans: IAmbassadorPlan[]=[];
    
    constructor(private plan: PlanService){


    }

    ngOnInit(): void {
        this.plan.getAmbassadorPlans(this.fileName).subscribe(s => this.plans = s);
    }


}
